class MovingBulbs {
    constructor(element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-research-ai-landingpage-movingbulbs',
            speedValue: 'data-research-ai-landingpage-movingbulbs-speed',
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);
        this.resizeHandler = window.resizeHandler;
        this.currentMouseX = 0;
        this.currentMouseY = 0;

        // Elements
        this.$movingBulbs = element;
        this.$$shapes = this.$movingBulbs.querySelectorAll(`[${ this.settings.speedValue }]`);
        this.animationFrameId = null;
    }

    initialize() {
        if (this.$$shapes.length > 0 && window.innerWidth >= 768) {
            this.setEvents();
        }
    }

    moveBulbs(speed, translation) {
        let lastMouseX = 0;
        let lastMouseY = 0;
        // Arrays to store interpolated (lerped) X and Y values for each shape
        const lerpX = [];
        const lerpY = [];
        // Translation and speed factor parameters
        const translate = translation;
        const speedFactor = speed;
        // Variables to store the root element's dimensions and center position
        let rootRect, rootCenterX, rootCenterY;

        // Function to update the root element's metrics (size and center position)
        const updateRootMetrics = () => {
            rootRect = this.$movingBulbs.getBoundingClientRect();
            rootCenterX = rootRect.left + rootRect.width / 2;
            rootCenterY = rootRect.top + rootRect.height / 2;
        };
        // Initialize lerped positions for each shape
        this.$$shapes.forEach(($shape, index) => {
            lerpX[index] = 0;
            lerpY[index] = 0;
        });

        // Initial update of root metrics and setup resize event listener
        updateRootMetrics();

        this.resizeHandler.customFunctions.push(() => {
            updateRootMetrics();
        });

        // Linear interpolation function to smoothly transition between values
        const lerp = (start, end, factor) => (1 - factor) * start + factor * end;

        // Animation function to move shapes based on mouse movement
        const animate = () => {
            if (this.currentMouseX !== lastMouseX || this.currentMouseY !== lastMouseY) {
                this.$$shapes.forEach(($shape, index) => {
                    // Calculate direction and distance for shape movement
                    const speed = Number($shape.getAttribute(this.settings.speedValue)) || 1;
                    const dx = (this.currentMouseX - rootCenterX) / (rootRect.width / 2) * translate * speed;
                    const dy = (this.currentMouseY - rootCenterY) / (rootRect.height / 2) * translate * speed;

                    // Apply linear interpolation for smooth movement
                    lerpX[index] = lerp(lerpX[index], dx, speedFactor);
                    lerpY[index] = lerp(lerpY[index], dy, speedFactor);

                    // Update shape position
                    $shape.style.transform = `translate3d(${ lerpX[index] }px, ${ lerpY[index] }px, 0)`;
                });
                // Update last mouse position
                lastMouseX = this.currentMouseX;
                lastMouseY = this.currentMouseY;
            }
        };

        animate();
    }

    setEvents() {
        let lastTime = 0;

        const handleMouseMove = (event) => {
            const now = Date.now();

            if (now - lastTime >= 300) {
                requestAnimationFrame(() => {
                    this.currentMouseX = event.clientX;
                    this.currentMouseY = event.clientY;

                    this.moveBulbs(1, 20);
                    lastTime = now;
                });
            }
        };

        this.$movingBulbs.addEventListener('mousemove', handleMouseMove);
    }
}

export { MovingBulbs };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$$movingBulbs = $context.querySelectorAll('[data-research-ai-landingpage-movingbulbs="root"]');
        for (let i = 0; i < $$$movingBulbs.length; i++) {
            const $$movingBulbs = $$$movingBulbs[i];

            const $$movingBulbsAPI = new MovingBulbs($$movingBulbs);
            $$movingBulbsAPI.initialize();
        }
    }
});
